import * as config from "../config.js";

export const getWebRTCToken = async (event_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/webrtc/get-token/${event_id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );

  const results = await response.json();
  console.log("!!! RESULTS: ", results);

  if (results.success) {
    return results.token;
  }

  return null;
};

export const getCollaboratorWebRTCToken = async (event_id, collaborator_id, invitation_token) => {
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/webrtc/get-collaborator-token/event_id`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        event_id,
        collaborator_id,
        invitation_token,
      }),
    }
  );

  const results = await response.json();
  console.log("!!! RESULTS: ", results);

  if (results.success) {
    return results.token;
  }

  return null;
};


export const startWebRTCRecording = async (roomName) => {
  // We dispatch requestLogin to kickoff the call to the API
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/webrtc/start-recording/${roomName}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );

  const results = await response.json();
  console.log("!!! RESULTS: ", results);

  if (results.success) {
    return results;
  }

  return null;
};

export const stopWebRTCRecording = async (roomName) => {
  // We dispatch requestLogin to kickoff the call to the API
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/webrtc/stop-recording/${roomName}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );

  const results = await response.json();
  console.log("!!! RESULTS: ", results);

  if (results.success) {
    return results;
  }

  return null;
};
